import { ref } from "vue";

const refreshTitleBarKey = ref(0);
const refreshNavigationBarKey = ref(0);

/**
 * Trigger a title‑bar refresh by bumping its key.
 */
function refreshTitleBar(): void {
  refreshTitleBarKey.value++;
}

/**
 * Trigger a navigation‑bar refresh by bumping its key.
 */
function refreshNavigationBar(): void {
  refreshNavigationBarKey.value++;
}

/**
 * Composable to force‑refresh UI components.
 */
export function useRefreshComponent() {
  return {
    refreshTitleBarKey,
    refreshTitleBar,
    refreshNavigationBarKey,
    refreshNavigationBar,
  };
}
